module.exports = __webpack_public_path__ + "media/images/color_admin_v3/transparent/black-0.5-6942b9d783db15cc13aa0378366185d8.png";